module.exports = __webpack_public_path__ + "static/media/blingV3_10.c8de093a.png";